<template>
    <div class="mobile">
        <div class="container mobile__container">
            <div class="mobile__wrapper">
                <div class="mobile__about">
                    <h1 class="mobile__title">Create a web version of the site on your smartphone</h1>
                    <div class="mobile__inner">
                        <div class="mobile__links">
                            <div class="mobile__title">Create a web version of the site on your smartphone</div>
                            <div class="mobile__links-block">
                                <router-link
                                to="#android"
                                class="mobile__link mobile__link--android"
                            >Users Andriod</router-link>
                            <router-link
                                to="#ios"
                                class="mobile__link mobile__link--ios"
                            >Users iOS</router-link>
                            </div>
                            <p class="mobile__text">We don't have an app for iOS and Android yet, but you can create a web
                                version of <a class="mobile-steps__link" :href="originLink">{{originLinkTitle}}</a> on your smartphone</p>
                        </div>
                        <div class="mobile__image">
                            <img class="mobile__img" :src="`/static/${aliasFormatted}/mobile-instruction/main.png`" alt="instruction">
                        </div>
                    </div>
                </div>
                <ul class="mobile__list">
                    <li class="mobile__item" v-for="item in listOfTypesOs" :id="item">
                        <h2 class="mobile__title" v-html="$t(`components.pages.mobile-instruction.${item}.title`)"></h2>
                        <ul class="mobile-steps">
                            <li v-for="n in 4" class="mobile-steps__item">
                                <img class="mobile-steps__img" :src="`/static/${aliasFormatted}/mobile-instruction/${item}/${n}.jpg`" :alt="`step ${n}`">
                                <div class="mobile-steps__inner">
                                    <div class="mobile-steps__number">{{ n }}</div>
                                </div>
                                <div class="mobile-steps__text" v-html="$t(`components.pages.mobile-instruction.${item}.step-${n}`, {'title' : title, 'link' : originLink, 'linkTitle' : originLinkTitle})"></div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

export default {
    name: 'mobile-instruction',
    computed: {
        client() {
            return Vue.state.client.get();
        },
        alias() {
            return this.client.view.general.alias;
        },
        aliasLowercase(){
            return this.alias.toLowerCase();
        },
        aliasFormatted() {
            return this.aliasLowercase != 'cashcasino' ? this.aliasLowercase : 'cash';
        },
        title() {
            return this.alias;
        },
        location() {
            return window.location;
        },
        originLink() {
            return this.location.origin;
        },
        originLinkTitle() {
            return this.location.host;
        },
        listOfTypesOs() {
            return ['android', 'ios'];
        }
    }
}
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/mobile-instruction/mobile-instruction.vue